import { render, staticRenderFns } from "./ResourceDownload.vue?vue&type=template&id=44785b5a&scoped=true&"
import script from "./ResourceDownload.vue?vue&type=script&lang=js&"
export * from "./ResourceDownload.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDownload.vue?vue&type=style&index=0&id=44785b5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44785b5a",
  null
  
)

export default component.exports